import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JeevesModalService } from 'gung-standard-jeeves';
import { Product } from 'gung-standard';
import { CarLinerIncludedItemsModalComponent } from '../components/car-liner-included-items-modal/car-liner-included-items-modal.component';
import { CarLinerBrochuresAddModalComponent } from '../components/car-liner-brochures-add-modal/car-liner-brochures-add-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerModalService extends JeevesModalService {
  constructor(protected modalService: NgbModal) {
    super(modalService);
  }

  openIncludedItemsModal(product: Product) {
    this.modalRef = this.modalService.open(CarLinerIncludedItemsModalComponent, this.modalOptions);
    this.modalRef.componentInstance.product = product;
    this.modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  openBrochuresAddModal(productIds: string[], product: Product, maxQty: number): Promise<any> {
    this.modalRef = this.modalService.open(CarLinerBrochuresAddModalComponent, this.modalOptions);
    this.modalRef.componentInstance.productIds = productIds;
    this.modalRef.componentInstance.product = product;
    this.modalRef.componentInstance.maxQty = maxQty;
    return this.modalRef.result
  }
}
